import { Factory } from '../..';

export enum CommunicationChannelConfigurationType {
  Email = 'Email',
  SMS = 'Sms'
}

export class CommunicationChannelConfiguration {
  type: CommunicationChannelConfigurationType;
  constructor(json: any) {
    this.type = json.type;
  }

  public static getFactory(): Factory<CommunicationChannelConfiguration> {
    return new (class implements Factory<CommunicationChannelConfiguration> {
      make(json: any): CommunicationChannelConfiguration {
        switch (json.type) {
          case CommunicationChannelConfigurationType.Email:
            return new EmailCommunicationChannelConfiguration(json);
          case CommunicationChannelConfigurationType.SMS:
            return new SMSCommunicationChannelConfiguration(json);
          default:
            throw new Error('Unrecognized CommunicationChannelConfiguration type (' + json.type + ').');
        }
      }

      getTableName(): string {
        return 'CommunicationChannelConfigurations are never stored in IndexedDB.';
      }
    })();
  }
}

export class EmailCommunicationChannelConfiguration extends CommunicationChannelConfiguration {
  templateId: string;
  subject: string;
  /** When true, the insurance-letter PDF is attached to this email flow. */
  attachPdf: boolean;
  constructor(json: any) {
    super(json);
    this.templateId = json.templateId;
    this.subject = json.subject;
    this.attachPdf = json.attachPdf ?? false;
  }
}

export class SMSCommunicationChannelConfiguration extends CommunicationChannelConfiguration {
  messageTemplate: string;

  constructor(json: any) {
    super(json);
    this.messageTemplate = json.messageTemplate;
  }
}
